import { IconSymbols } from "@flightpath/coreui/dist/generated/IconSymbols";
import { ButtonTypes } from "../../../components/ui/Button";
import I18n from "../../../core/localization/I18n";
import { IUiAction, UiActionRenderers } from "../../../core/uiAction/IUiAction";
import { UiSizes } from "../../../enums";
import { ChangePages } from "../../change/routes/pages";
import { ProcessPages } from "../../processes/routes/pages";
import { ShellPages } from "../routes/shellPages";
import { TrainingPages } from "../../training/routes/pages";
import dashboardIcon from "../../../components/widgets/navigation/icons/cottage.svg";
import dashboardActiveIcon from "../../../components/widgets/navigation/icons/cottage-active.svg";
import organisationDashboardIcon from "../../../components/widgets/navigation/icons/apartment.svg";
import organisationDashboardActiveIcon from "../../../components/widgets/navigation/icons/apartment-active.svg";
import programmeOverviewIcon from "../../../components/widgets/navigation/icons/view_object_track.svg";
import programmeOverviewActiveIcon from "../../../components/widgets/navigation/icons/view_object_track-active.svg";
import changeIcon from "../../../components/widgets/navigation/icons/change_history.svg";
import changeActiveIcon from "../../../components/widgets/navigation/icons/change_history-active.svg";
import processesIcon from "../../../components/widgets/navigation/icons/step.svg";
import processesActiveIcon from "../../../components/widgets/navigation/icons/step-active.svg";
import trainingActiveIcon from "../../../components/widgets/navigation/icons/school-active.svg";
import trainingIcon from "../../../components/widgets/navigation/icons/school.svg";
import surveysActiveIcon from "../../../components/widgets/navigation/icons/ballot-active.svg";
import surveysIcon from "../../../components/widgets/navigation/icons/ballot.svg";
import impactsActiveIcon from "../../../components/widgets/navigation/icons/local_fire_department-active.svg";
import impactsIcon from "../../../components/widgets/navigation/icons/local_fire_department.svg";
import actionsIcon from "../../../components/widgets/navigation/icons/checklist.svg";
import actionsActiveIcon from "../../../components/widgets/navigation/icons/checklist-active.svg";
import stakeholdersIcon from "../../../components/widgets/navigation/icons/person_heart.svg";
import stakeholdersActiveIcon from "../../../components/widgets/navigation/icons/person_heart-active.svg";
import audiencesIcon from "../../../components/widgets/navigation/icons/groups.svg";
import audiencesActiveIcon from "../../../components/widgets/navigation/icons/groups-active.svg";
import readinessIcon from "../../../components/widgets/navigation/icons/planner_review.svg";
import readinessActiveIcon from "../../../components/widgets/navigation/icons/planner_review-active.svg";
import SurveyPages from "../../survey/routes/pages";

export const DashboardsItemsConfig: (organisationId, programmeId, projectId, isProgramme) => IUiAction<any>[] = (
  organisationId,
  programmeId,
  projectId,
  isProgramme
) => [
  {
    id: "dashboard",
    label: I18n.t("phrases.myDashboard"),
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      size: UiSizes.MD,
      className: `mb-1 side-nav__item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: dashboardIcon,
      href: ShellPages.dashboards.index.generateLink(organisationId)
    }
  },
  {
    id: "organisationDashboard",
    label: I18n.t("phrases.organisation"),
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      size: UiSizes.MD,
      className: `mb-1  side-nav__item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: organisationDashboardIcon,
      href: ShellPages.organisations.visualisations.heatmap.generateLink(organisationId, "business-areas")
    }
  },
  {
    id: "programmeOverview",
    label: I18n.t("phrases.programme"),
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      size: UiSizes.MD,
      className: `mb-1  side-nav__item`,
      isDisabled: !isProgramme,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: programmeOverviewIcon,
      href: ShellPages.programmes.index.generateLink(organisationId, programmeId)
    }
  },
  {
    id: "projectOverview",
    label: I18n.t("phrases.project"),
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      size: UiSizes.MD,
      className: `mb-1  side-nav__item`,
      isDisabled: !projectId,
      type: ButtonTypes.LINK,
      symbol: IconSymbols.Projects,
      href: ShellPages.projects.index.generateLink(organisationId, projectId)
    }
  }
];

export const ProjectNavItemsConfig = (
  setView: (val: "change" | "training" | "processes" | "surveys") => void,
  organisationId,
  projectId,
  currentView
) => [
  {
    id: "change",
    label: I18n.t("phrases.change"),
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {
      setView(currentView === "change" ? null : "change");
    },
    componentProps: {
      showLabel: true,
      href: "#",
      size: UiSizes.MD,
      className: `mb-1 side-nav__item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: changeIcon
    }
  },
  {
    id: "processes",
    label: I18n.t("phrases.processes"),
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      href: ProcessPages.reports.generateLink(organisationId, projectId),
      size: UiSizes.MD,
      className: `mb-1 side-nav__item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: processesIcon
    }
  },
  {
    id: "training",
    label: I18n.t("phrases.training"),
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      href: TrainingPages.learningDashboard.generateLink(organisationId, projectId),
      size: UiSizes.MD,
      className: `mb-1 side-nav__item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: trainingIcon
    }
  },
  {
    id: "surveys",
    label: I18n.t("phrases.surveys"),
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      href: SurveyPages.index.generateLink(organisationId, projectId),
      size: UiSizes.MD,
      className: `mb-1 side-nav__item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: surveysIcon
    }
  }
];

export const ChangeNavItemsConfig = (organisationId, _, projectId) => [
  {
    id: "impacts",
    label: I18n.t("phrases.impacts"),
    icon: IconSymbols.Impacts,
    isActiveOnAllTabs: "impact",
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      size: UiSizes.MD,
      className: `mb-1 side-nav__item side-nav__sub-item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: impactsIcon,
      href: ChangePages.impacts.visualisations.impactAssesment.generateLink(organisationId, projectId)
    }
  },
  {
    id: "actions",
    label: I18n.t("phrases.actions"),
    icon: IconSymbols.Actions,
    isActiveOnAllTabs: "actions",
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      size: UiSizes.MD,
      className: `mb-1 side-nav__item side-nav__sub-item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: actionsIcon,
      href: ChangePages.actions.visualisations.index.generateLink(organisationId, projectId)
    }
  },
  {
    id: "stakeholders",
    label: I18n.t("phrases.stakeholders"),
    icon: IconSymbols.User,
    isActiveOnAllTabs: "stakeholders",
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      size: UiSizes.MD,
      className: `mb-1 side-nav__item side-nav__sub-item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: stakeholdersIcon,
      href: ChangePages.stakeholders.visualisations.index.generateLink(organisationId, projectId)
    }
  },
  {
    id: "audiences",
    label: I18n.t("phrases.audiences"),
    icon: IconSymbols.Stakeholders,
    isActiveOnAllTabs: "audiences/visualisations",
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      size: UiSizes.MD,
      className: `mb-1 side-nav__item side-nav__sub-item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: audiencesIcon,
      href: ChangePages.audiences.visualisations.index.generateLink(organisationId, projectId)
    }
  },
  {
    id: "readiness",
    label: I18n.t("phrases.readiness"),
    icon: IconSymbols.Stakeholders,
    isActiveOnAllTabs: "readiness-charts",
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      size: UiSizes.MD,
      className: `mb-1 side-nav__item side-nav__sub-item`,
      type: ButtonTypes.LINK,
      isSymbolImage: true,
      symbol: audiencesIcon,
      href: ChangePages.audiences.readinessChartsView.generateLink(organisationId, projectId)
    }
  }
];

export const NavIconsConfig = (active: boolean) => [
  { id: "dashboard", icon: active ? dashboardActiveIcon : dashboardIcon },
  { id: "organisationDashboard", icon: active ? organisationDashboardActiveIcon : organisationDashboardIcon },
  { id: "programmeOverview", icon: active ? programmeOverviewActiveIcon : programmeOverviewIcon },
  { id: "projectOverview", icon: IconSymbols.Projects },
  { id: "change", icon: active ? changeActiveIcon : changeIcon },
  { id: "processes", icon: active ? processesActiveIcon : processesIcon },
  { id: "training", icon: active ? trainingActiveIcon : trainingIcon },
  { id: "surveys", icon: active ? surveysActiveIcon : surveysIcon },
  { id: "impacts", icon: active ? impactsActiveIcon : impactsIcon },
  { id: "actions", icon: active ? actionsActiveIcon : actionsIcon },
  { id: "stakeholders", icon: active ? stakeholdersActiveIcon : stakeholdersIcon },
  { id: "audiences", icon: active ? audiencesActiveIcon : audiencesIcon },
  { id: "readiness", icon: active ? readinessActiveIcon : readinessIcon }
];

export const SurveysNavItemsConfig = (organisationId, _, projectId) => [
  {
    id: "surveys",
    label: I18n.t("phrases.list"),
    rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
    onAction: () => {},
    componentProps: {
      showLabel: true,
      size: UiSizes.MD,
      className: `mb-1 side-nav__item side-nav__sub-item`,
      type: ButtonTypes.LINK,
      symbol: IconSymbols.List,
      href: SurveyPages.index.generateLink(organisationId, projectId)
    }
  }
];

//   {
//     id: "components",
//     label: I18n.t("phrases.components"),
//     rendersIn: UiActionRenderers.LINK_BUTTON_ICON,
//     onAction: () => {},
//     componentProps: {
//       showLabel: true,
//       size: UiSizes.MD,
//       className: `mb-1 side-nav__item side-nav__sub-item`,
//       type: ButtonTypes.LINK,
//       symbol: IconSymbols.CommentPencil,
//       href: TrainingPages.moduleReporting.generateLink(organisationId, projectId)
//     }
//   }

// learningMenu: {
//   id: "learningMenu",
//   label: I18n.t("phrases.trainingOverview"),
//   icon: IconSymbols.Book,
//   subItems: [
//     {
//       id: "coursesOverview",
//       label: I18n.t("phrases.courses"),
//       icon: IconSymbols.BookOpen,
//       href: (organisationId, projectId) => TrainingPages.courseReporting.generateLink(organisationId, projectId),
//       test: "courses"
//     },
//     {
//       id: "modulesOverview",
//       label: I18n.t("phrases.modules"),
//       icon: IconSymbols.WorkshopMode,
//       href: (organisationId, projectId) => TrainingPages.moduleReporting.generateLink(organisationId, projectId),
//       test: "modules"
//     },
//     {
//       id: "componentsOverview",
//       label: I18n.t("phrases.components"),
//       icon: IconSymbols.CommentPencil,
//       href: (organisationId, projectId) => TrainingPages.moduleReporting.generateLink(organisationId, projectId),
//       test: "components"
//     }
//   ]
// }
// surveyMenu: {
//   id: "surveyMenu",
//   label: I18n.t("phrases.surveys"),
//   icon: IconSymbols.Server,
//   subItems: [
//     {
//       id: "surveysOverview",
//       label: I18n.t("phrases.overview"),
//       icon: IconSymbols.Globe,
//       href: "/organisations/{orgId}/projects/{projId}/survey/overview",
//       test: "overview"
//     },
//     {
//       id: "allSurveysOverview",
//       label: I18n.t("phrases.allSurveys"),
//       icon: IconSymbols.FileText,
//       href: "/organisations/{orgId}/projects/{projId}/survey/surveys",
//       test: "survey/surveys"
//     },
//     {
//       id: "templatesOverview",
//       label: I18n.t("phrases.templates"),
//       icon: IconSymbols.File,
//       href: "/organisations/{orgId}/projects/{projId}/survey/templates",
//       test: "templates"
//     }
//   ]
// }
